import { render, staticRenderFns } from "./ReportQrCode.vue?vue&type=template&id=146af90a&lang=pug&"
import script from "./ReportQrCode.vue?vue&type=script&lang=ts&"
export * from "./ReportQrCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports